import React, { ButtonHTMLAttributes, DetailedHTMLProps } from 'react';
import clsx from 'clsx';

import styles from './Button.module.css';

type ButtonProps = {
  children?: React.ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  transparentHover?: boolean;
  highlighted?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'destructive' | 'link' | 'outline' | 'chip' | 'destructive-outline';
  width?: 'auto' | 'full';
} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export function Button({
  children,
  type = 'button',
  size = 'large',
  variant = 'outline',
  width = 'auto',
  disabled,
  highlighted,
  className,
  ref,
  ...rest
}: ButtonProps & { ref?: React.Ref<HTMLButtonElement> }) {
  return (
    <button
      type={type}
      className={clsx(
        styles.button,
        styles[variant],
        styles[size],
        styles[width],
        { [styles.disabled]: disabled, [styles.highlighted]: highlighted },
        className,
      )}
      disabled={disabled}
      ref={ref}
      {...rest}
    >
      {children}
    </button>
  );
}
